import React from 'react';


const LocationIcon = ({ style = {}, fill = 'var(--text-level-3)', width = '16', height = '16', className = '', viewBox = '0 0 16 16' }) => (
  <svg width={width} style={style} height={height} viewBox={viewBox} className={className} fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.00001 1C5.10052 1 2.75 3.36274 2.75 6.27735C2.75 7.25206 2.9398 8.25878 3.48445 8.98438L8.00001 15L12.5155 8.98438C13.0103 8.32533 13.25 7.16022 13.25 6.27735C13.25 3.36274 10.8995 1 8.00001 1ZM8.00001 4.05652C9.22001 4.05652 10.2093 5.05099 10.2093 6.27733C10.2093 7.5037 9.22001 8.49817 8.00001 8.49817C6.78001 8.49817 5.79069 7.5037 5.79069 6.27735C5.79069 5.05099 6.78001 4.05652 8.00001 4.05652Z" fill={fill} />
  </svg>
);
export default LocationIcon;
